import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { FC, ReactNode } from "react";
import {
  ThemeProvider,
  FileQueueProvider,
  NotificationProvider,
  ErrorBoundary,
} from "@epcnetwork/core-ui-kit";

import store from "store";
import { lightTheme } from "constants/themes.constants";
import { DEFAULT_PAGE } from "constants/routes.constants";
import { AuthorizationGuard } from "../authorization";

const themes = [lightTheme];

interface ProvidersProps {
  children: ReactNode;
}

const Providers: FC<ProvidersProps> = ({ children }) => {
  const handleRefresh = () => (window.location.href = DEFAULT_PAGE.path);

  return (
    <Provider store={store}>
      <AuthorizationGuard>
        <BrowserRouter>
          <ErrorBoundary
            title="Oops! Something went wrong"
            subtitle="Page could not be loaded. Please try later"
            refreshText="Go to homepage"
            refreshClick={handleRefresh}
          >
            <ThemeProvider themes={themes} initialTheme={themes[0]}>
              <FileQueueProvider>
                <NotificationProvider>{children}</NotificationProvider>
              </FileQueueProvider>
            </ThemeProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </AuthorizationGuard>
    </Provider>
  );
};

export { Providers };
